// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"274":"24262301","470":"304bd571","478":"66ef3d11","615":"24262301"}[chunkId] + ".chunk.css";
};